import Vue from 'vue';

export function t(value: string, args?: Record<string, any>): string {
  // translates and removes dashes in case of failure to translate
  return Vue.prototype.$t(value, args);
}
